// extracted by mini-css-extract-plugin
export default {"hitsOfTheWeekSlider":"HitsOfTheWeek_hitsOfTheWeekSlider__suW1I","prev":"HitsOfTheWeek_prev__gZQ1S","next":"HitsOfTheWeek_next__xUuyW"};